import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { IAuctionListing } from '../../../../models/IAuctionListing';
import { AbsoluteMediaUriService } from '../../../../services/absolute-media-uri.service';
import { CommonModule } from '@angular/common';
import { SanitizeHtmlTextPipe } from '../../../../shared/pipes/sanitize-html-text.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { ApiService } from '../../../../services/api.service';
import { DateFormatService } from '../../../../services/date-format/date-format.service';
import { TimeLeftService } from '../../../../services/time-left.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AuctionListingService } from '../../../../services/bidder-community/auction-listing/auction-listing.service';
import { faBookmark as faBookmarkSolid } from '@fortawesome/free-solid-svg-icons';
import { faBookmark as faBookmarkRegular } from '@fortawesome/free-regular-svg-icons';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subscription } from 'rxjs';
import { MyAuctionsService } from '../../../../services/bidder-community/my-auctions/my-auctions.service';
import { AuthService, LOGIN_TYPE_TOPBAR } from '../../../../services/authentication/auth.service';
import { RouterModule } from '@angular/router';


@Component({
  selector: 'app-auction-listing-vertical-view',
  imports: [CommonModule,
    SanitizeHtmlTextPipe,
    FontAwesomeModule,
    ProgressSpinnerModule,
    RouterModule
  ],
  templateUrl: './auction-listing-vertical-view.component.html',
  styleUrl: './auction-listing-vertical-view.component.scss'
})
export class AuctionListingVerticalViewComponent implements OnInit {

  @Input() auctions: IAuctionListing[] | null = null;

  @Output() myAuctionChanged = new EventEmitter<IAuctionListing | null>();


  faLocationDot = faLocationDot;
  faBookmarkSolid = faBookmarkSolid;
  faBookmarkRegular = faBookmarkRegular;
  isHomePage: boolean = false;
  formateDate!: string;

  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);
  protected readonly apiService = inject(ApiService);
  protected readonly dateFormatService = inject(DateFormatService);
  protected readonly timeLeftService = inject(TimeLeftService);
  protected readonly auctionListingService = inject(AuctionListingService);
  protected readonly oidcSecurityService = inject(OidcSecurityService);
  protected readonly myAuctionService = inject(MyAuctionsService);
  protected readonly authService = inject(AuthService);




  isLoading = this.auctionListingService.isLoading;
  isAuthenticated = this.oidcSecurityService.authenticated;
  authSubscription!: Subscription;


  formattedDates: Record<number, string> = {};

  ngOnInit(): void {

    this.auctions?.forEach(a => {
      this.formatAuctionDate(a.auctionClosingDate, a.auctionId);
    });
  }

  formatAuctionDate(date: string, auctionId: number): void {
    this.apiService.getAuctionConfig(auctionId).subscribe({
      next: (response) => {
        const timeZone = response.timezone;
        this.formattedDates[auctionId] =
          this.dateFormatService.formatDateWithTimezone(timeZone, date);
      }
    });
  }

  smartTitleCase(text: string): string {
    const lower = [
      'of', 'and', 'the', 'in', 'on', 'at', 'for', 'a', 'an', 'to'
    ];

    return text
      .toLocaleLowerCase()
      .split(' ')
      .map((word, index) => {
        if (index === 0) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }

        return lower.includes(word)
          ? word
          : word.charAt(0).toUpperCase() + word.slice(1);
      }).join(' ');
  }

  toggleFavorite(myAuction: IAuctionListing): void {

    if (!this.isAuthenticated().isAuthenticated) {
      this.openLoginModal(() => {
        this.onHandlerMyAuction(myAuction);
      });
    } else {
      this.onHandlerMyAuction(myAuction);
    }
  }

  onHandlerMyAuction(myAuction: IAuctionListing) {
    if (myAuction.isFavorite) {
      this.myAuctionService.deleteAuction(myAuction.auctionId).subscribe({
        next: () => this.myAuctionChanged.emit(myAuction)
      });
    } else {
      this.myAuctionService.putMyAuction(myAuction.auctionId).subscribe({
        next: () => this.myAuctionChanged.emit(myAuction)
      });
    }
  }

  openLoginModal(fun?: () => void) {
    this.authService.openLoginModal(LOGIN_TYPE_TOPBAR, fun ?? (() => { })
    );
  }

  protected getAuctionUrl(auction: IAuctionListing): string {
    if (auction.isUsing2025Design) {
      return '/auction/' + auction.auctionId;
    } else {
      return this.absoluteMediaUriService.getAbsoluteMediaUri(
        '/auction/auctionhome.action?auctionId=' + auction.auctionId
      );
    }
  }

}
